import AddressPage from "./AddressPage";
import registrationStep from "../../registrationStep";

// export default connect(
//   (state) => ({
//     currentRegistrationId: state.registration.currentRegistrationId,
//     currentRegistration: getCurrentRegistration(state)
//   }),
//   (dispatch) => ({
//     onSubmit: (registrationId, addressInfo) => dispatch(Creators.saveAddressInfo(registrationId, addressInfo))
//   })
// )(AddressPage);

export default registrationStep(AddressPage, "address", "id");



// WEBPACK FOOTER //
// ./src/registration/components/Address/index.js